import React from "react";
import { Button, Container, Row, Col, Form, Modal } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../AppContext';

export default class LocationEditor extends React.Component {
    dialogRef = React.createRef();
    state = {
        record: {}
    };

    constructor(props) {
        super(props);

        this.state.record = props.record || {};
    }

    render() {
        let record = this.state.record;
        return (
            <Modal
                onHide={ () => {
                    this.extraElement = null;
                    this.setState({});
                }}
                centered={ true }
                backdrop={ 'static' } show={true}
                ref={ this.dialogRef }
                size={'xl'}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Location</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ flexDirection: 'row' }}>
                    <Form.Group>
                        <Form.Label>Name</Form.Label>
                        <Form.Control 
                            type="text"
                            value={ this.state.record.name }
                            onChange={ (event) => {
                                record.name = event.target.value;
                                this.setState({ record: record })
                            }}
                        />
                    </Form.Group>
                    <div style={{ display: "block" }}>
                        <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                            <Form.Group>
                                <Form.Label>Email</Form.Label>
                                <Form.Control 
                                    type="text"
                                    value={ this.state.record.email }
                                    onChange={ (event) => {
                                        record.email = event.target.value;
                                        this.setState({ record: record })
                                    }}
                                />
                            </Form.Group>
                        </div>
                        <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                            <Form.Group>
                                <Form.Label>Phone</Form.Label>
                                <Form.Control 
                                    type="text"
                                    value={ record.phone }
                                    onChange={ (event) => {
                                        record.phone = event.target.value;
                                        this.setState({ record: record })
                                    }}
                                />
                            </Form.Group>
                        </div>
                    </div>
                    <div style={{ display: "block" }}>
                        <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                            <Form.Group>
                                <Form.Label>Country</Form.Label>
                                <Form.Control 
                                    type="text"
                                    value={ record.country }
                                    onChange={ (event) => {
                                        record.country = event.target.value;
                                        this.setState({ record: record })
                                    }}
                                />
                            </Form.Group>
                        </div>
                        <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                            <Form.Group>
                                <Form.Label>State</Form.Label>
                                <Form.Control 
                                    type="text"
                                    value={ record.state }
                                    onChange={ (event) => {
                                        record.state = event.target.value;
                                        this.setState({ record: record })
                                    }}
                                />
                            </Form.Group>
                        </div>
                        <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                            <Form.Group>
                                <Form.Label>Zip</Form.Label>
                                <Form.Control 
                                    type="text"
                                    value={ record.zip }
                                    onChange={ (event) => {
                                        record.zip = event.target.value;
                                        this.setState({ record: record })
                                    }}
                                />
                            </Form.Group>
                        </div>
                    </div>
                    <div style={{ display: "block" }}>
                        <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                            <Form.Group>
                                <Form.Label>City</Form.Label>
                                <Form.Control 
                                    type="text"
                                    value={ record.city }
                                    onChange={ (event) => {
                                        record.city = event.target.value;
                                        this.setState({ record: record })
                                    }}
                                />
                            </Form.Group>
                        </div>
                        <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                            <Form.Group>
                                <Form.Label>Address</Form.Label>
                                <Form.Control 
                                    type="text"
                                    value={ record.address }
                                    onChange={ (event) => {
                                        record.address = event.target.value;
                                        this.setState({ record: record })
                                    }}
                                />
                            </Form.Group>
                        </div>
                    </div>
                    <div style={{ display: "block" }}>
                        <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                            <Form.Group>
                                <Form.Label>Latitude</Form.Label>
                                <Form.Control 
                                    type="text"
                                    value={ record.latitude }
                                    onChange={ (event) => {
                                        record.latitude = event.target.value;
                                        this.setState({ record: record })
                                    }}
                                />
                            </Form.Group>
                        </div>
                        <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                            <Form.Group>
                                <Form.Label>Longitude</Form.Label>
                                <Form.Control 
                                    type="text"
                                    value={ this.state.record.longitude }
                                    onChange={ (event) => {
                                        record.longitude = event.target.value;
                                        this.setState({ record: record })
                                    }}
                                />
                            </Form.Group>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary"
                        onClick={ () => this.props.onClose() }
                    >Close</Button>
                    <Button variant="primary"
                        //disabled={ this.state.selectedList.length === 0 }
                        onClick={ () => this.props.onSave(record) }
                    >Save</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}